const DietLengthTypes = {
    SixToTwelveHours: 1,
    Above12Hours: 2
};

Object.freeze(DietLengthTypes);

export default DietLengthTypes;